import { ComboBox, DefaultButton, DirectionalHint, IComboBoxOption, IDropdownOption, Label, TextField , TooltipHost} from "@fluentui/react";
import { FormEvent, useEffect, useRef, useState } from "react";
import { convertHourToMin, convertMinToHour, FileUpload, formatDate, Iactivities, IconPapers, IListFile, LoadingPage } from "./FileUpload";
import { v4 as uuidv4 } from 'uuid';
import { DateCustom } from "../../lib/DateCustom";
import { useTranslation } from "react-i18next";
import { FormUploadHeader, HourMinuteInput, StatusIcon } from "./ImportAct";
import Custoneader from "./Custoneader";
import { AddIcon, IactError, IAddRows, ICollaborator, IComboBoxInput, ICompanyPanel, UploadIcon } from "./InterfaceFormulario";
import { IActivityRecurring, IAddRecurrentActivity, IPlantillaActividadesXColaborador, IPosplantillaActividadesColaborador, ItipoConcepto } from "../../system/projects/ProjectsSystem";
import { Callout } from "office-ui-fabric-react";
import useIsMobile from "../../common/custom-hooks/useIsMobile";
import Loading from "../Spinners/Loading";
import ActivityRow from "./ActivityRow";
import { normalizeText } from "../../lib/Util";
import HoursLimitDialog from "./HoursLimitDialog";
import XhrRequestError from "../../lib/XhrRequestError";

export interface IactivitiesBody {
  activities:Iactivities[];
  col_id: string;
  exercise_period: string;
  timezone: string;
}

export interface IactivitiesResponse {
  data:Iactivities[];
  error:string;
  type:string;
}

function CargarPorFormulario(props: ICompanyPanel) {
  const headers = { idTransaccion:uuidv4(), msgTransaccion:"horas Total Collaborator" }
  const { t, i18n } = useTranslation();
    const [addRows,setAddRows] = useState<IAddRows[]>([]);
    const [actError, setActError] = useState<IactError>({actVali:0,actvErro:0});
    const [desabled, setDesabled] = useState<boolean>(true);

    const [showHoursDialog, setShowHoursDialog] = useState(false);

    const [allCollaborators, setAllCollaborators] = useState<IComboBoxOption[]>([]);
    const [filteredCollaborators, setFilteredCollaborators] = useState<IComboBoxOption[]>([]);
    const [collaboratorValue, setCollaboratorValue] = useState<string>('');
    const [collaboratorId, setCollaboratorId] = useState<string>('');
    const [listFile, setListFile] = useState<IListFile[]>([]);

    const [periodo,setPeriod] = useState<Date>(DateCustom.getFirstDayOfThisMonth())
    const [horasTotal, setHorasTotal] = useState<number>(0);
    const [horasExcedidas, setHorasExcedidas] = useState<number>(0);
    const [desableAddRow, setDesableAddRow] = useState<boolean>(false);
    const previousValuesMap = useRef<Map<string, number>>(new Map());

    const [mountBlock, setMountBlock] = useState<{[key: number]: number[]}>({});
    const [horasTotalCollaborator,setHorasTotalCollaborator] = useState<number>(0);
    const actividadRecurrentenbasic:IActivityRecurring  = {
      ar_id:"",ar_nombre_descripcion:"",ar_proy_id:"",key:"",
      text:"",ar_activo:1,ar_date_created:new Date(),ar_date_modified:new Date(),ar_eliminado:0,
      ar_nombre_act:"",ar_user_created:"web",ar_user_modified:"web", ar_pais_id: 1, ar_empresa_id:1
    };
    const [listCountries, setListCountries] = useState<any[]>([]);
    const [listtipoConcept,setListtipoConcept] = useState<ItipoConcepto[]>([]);
    const [filterTipoConsept, setFilterTipoConsept] = useState<ItipoConcepto[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { isMobile } = useIsMobile();
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [showCallout, setShowCallout] = useState(false);
    const iconRef = useRef(null);

    const aiActivityEnhancementSystem= props.system.getAiActivityEnhancementSystem()
    
    useEffect(() => {
      // Calcular el total de horas que se intenta registrar en el mes
      const totalHorasCargadas = addRows.reduce((acc, row) => acc + convertHourToMin(row.horasCarg), 0);

      // Validar si excede el límite de horas
      if (totalHorasCargadas > horasTotalCollaborator) {
        props.courier.messageWarning(
          `Has superado las horas establecidas para este mes.
          Puedes modificar las horas antes de registrar tus actividades.
          [Recuerda que solo se permite un máximo de 3 horas extras por día, ${horasExcedidas.toString().split(":")[0]} horas extras al mes.]`
        );
      } else {
        if (addRows.length > 0 && totalHorasCargadas > 0) {
          props.courier.messageWarning('')
        }
      }
    }, [addRows, horasTotalCollaborator])
    const updateActivityNameAndDescription = (
      id: string,
      newNombreAct: string,
      newDescripcion: string
    ) => {
      setAddRows(prev => {
        const updatedRows = prev.map((row) => {
          if (row.id === id) {
            return {
              ...row,
              nombreAct: newNombreAct,
              descripcion: newDescripcion,
            };
          }
          return row;
        });
        // Validar la fila actualizada en tiempo real
        validateRowById(updatedRows, id);
        return updatedRows;
      });
    };

    const getAllPeriodBlocks = async () => {
      const periodBlocks = await props.system.getAllPeriodsBlocked();
      const newMountBlocks = periodBlocks
          .map(data => ({ year: data.getFrom().year, month: data.getFrom().month }))
          .reduce((acc, { year, month }) => {
              if (!acc[year]) acc[year] = [];
              acc[year].push(month);
              return acc;
          }, {} as { [key: number]: number[] });
      setMountBlock(newMountBlocks);
  };

    const handleSelectCollaborator =async (option: IComboBoxOption | undefined) => {
      props.changeBlockUI(true);
      cleanActiveProject();
      setCollaboratorValue(option?.text || "");
      if (option?.key !== undefined) {
        const data = String(option.key);
        setCollaboratorId(data);
        const exercise_period = formatDate(periodo);
        await  getHorasTal(data,exercise_period);
      }
      props.changeBlockUI(false);
    };

    const getIdfolder= async (id:string)=>{
      const respuesta = await props.system.getActivitySystem().IdFolder(id);
      return respuesta;
    }

    const handleFilterCollaborator = (text: string) => {
      setCollaboratorValue(text);
      const data = allCollaborators.filter(g => g.text.toLowerCase().includes(text.toLowerCase()));
      setFilteredCollaborators(data);
    };

    const formatCollaboratorData = (data: ICollaborator[]) => {
      const result: IComboBoxOption[] = data.map(col => ({
        key: col.id,
        text: `${col.name} ${col.lastName}`,
        active: col.active,
        email: col.email
      }));
      if (!result) return;
      setAllCollaborators(result);
      setFilteredCollaborators(result);
    };

    const fetchCollaborators = async () => {
      try {
        const data = await props.system.getActivitySystem().getCommonContext();
        formatCollaboratorData(data.colaboradores as ICollaborator[]);
      } catch (error) {
        console.error('Error fetching collaborators:', error);
      }
    };

    const fetchProjects = async (userData:string,periodo:string,tipoConcept:string | number |undefined) => {
      try {
        const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(userData,periodo,tipoConcept);
        const transformsci =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode(), pro_inicio:  v.getStart(), pro_fin: v.getEnd() }));
        return transformsci
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    const fetchCompany = async (userData:string,periodo:string,tipoConcept:string | number |undefined) => {
      try {
        const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(userData,periodo,tipoConcept);
        const transformsci =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode() }));
        return transformsci
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    }

    const getLisTipoConcept = async ()=>{
       try{
        const data = await props.system.getProjectSystem().gettipoConsepto(headers.idTransaccion);
        setListtipoConcept(data);
        setFilterTipoConsept(data);
       }catch(error){
        console.log('error fetching tipo concept', error);
       }
    };

    const getListCountries = async () => {
      try{
        const data = await props.system.getCountrySystem().getDataCountries();
        const options: IComboBoxOption[] = data.map((country) => ({
          key: country.pais_id,
          text: country.pais_nombre,
        }));
        setListCountries(options);
       }catch(error){
        console.log('error fetching tipo concept', error);
       }
    }

    const validateRow = (row: IAddRows, id?: string) => {
      let descripcionError = "";
      const nombreActValido = /^[^\s]/.test(row.nombreAct) && !/\s{2,}/.test(row.nombreAct);
      const regex = /^(?:\d{1,3}:)?(\d{1,2}|undefined)?$/;
      const segundoRegex = /^:\d{1,2}$/;
      const valorMin =  convertHourToMin(row.horasCarg)
      const regexUndefine = /:undefined|undefined/;
      if ((!row.nombreAct && !row.horasCarg) || ( !row.nombrePro?.text && !row.horasCarg) || (!row.tipoConcepto?.text) || (!row.nombreEmp?.text)) {
        descripcionError = t("Los campos obligatorios (*) no pueden ser vacíos");
      } else {
        if(!nombreActValido && (!row.nombrePro || !row.nombrePro.text)){
          descripcionError = t("Los campos obligatorios (*) no pueden ser vacíos");
        }else if (!nombreActValido) {
          descripcionError = "El nombre de la actividad no puede ser vacío. ";
          if (!row.paisEmpresa.text){
            descripcionError = "El pais de la empresa no puede ser vacío. ";
          } else if (!row.nombreEmp || !row.nombreEmp.text){
            descripcionError = "El nombre de la empresa no puede ser vacío. ";
          }
        }
        else if (row.nombreAct?.length <= 3) {
          descripcionError = t("El nombre es muy corto.");
        }else if (!row.nombrePro.text) {
          descripcionError = t("Nombre de proyecto vacío.");
        }
        if (!row.horasCarg) {
          descripcionError = t("Horas está vacío.");
        } else if(valorMin === 0){
          if( !row.nombreAct || row.nombreAct === ""){
            descripcionError = t("Los campos obligatorios (*) no pueden ser vacíos");
          }else if((valorMin === 0) && !row.nombrePro.text){
            descripcionError = t("Los campos obligatorios (*) no pueden ser vacíos");
          } else{
             descripcionError = t("Hora no valida");
          }
        }else if (!regex.test(row.horasCarg) && !segundoRegex.test(row.horasCarg) && regexUndefine.test(row.horasCarg)) {
          descripcionError = t("Horas solo admite números.");
        }

        
        if (id) {
          if (row.horasCarg === ":undefined" || row.horasCarg === "" || !row.horasCarg) {

            const prevValue = previousValuesMap.current.get(id) || 0;
            setHorasTotal(horasTotal + prevValue);
            previousValuesMap.current.delete(id);
          } else if (regex.test(row.horasCarg) || segundoRegex.test(row.horasCarg)) {
            const minIngresados = convertHourToMin(row.horasCarg);
            const prevValue = previousValuesMap.current.get(id) || 0;
            setHorasTotal(prevHorasTotal => prevHorasTotal + prevValue - minIngresados);
            previousValuesMap.current.set(id, minIngresados);
          }
        }
      }
    
      return { ...row, descripcionError, valida: descripcionError ? 0 : 1 };
    };

    const validateRowById = (rows: IAddRows[], id: string) => {

      const updatedRows = rows.map(row => row.id === id ? validateRow(row,row.id) : row);
      setAddRows(updatedRows);
      HandlerNumError(updatedRows);
    };

    const HandlerAddRows = () => {
      const newdata: IAddRows = {
        id: uuidv4(),
        nombrePro: { key: "", text: "" },
        nombreAct: "",
        horasCarg: "",
        file: "",
        valida: 2,
        descripcionError: t("nueva fila"),
        actividadRecurrente:"si",
        lisActRecurrente:[],
        actividadRecurrenteSelect:actividadRecurrentenbasic,
        tipoConcepto:{key:"",text:"",codigo:""},
        listaProyectos:[],
        listaEmpresa:[],
        filterListProyectos:[],
        descripcion:"",
        paisEmpresa: { key: "", text: "" },
        nombreEmp:{ key: "", text: "" },
        options:0,
        files: []
      };
      setAddRows([...addRows, newdata]);
      setDesabled(true);
    };

    const HandlercleanEverything = ()=>{
      setAddRows([]);
      setHorasTotal(horasTotalCollaborator);
      setDesabled(true);
      setLoading(false);
    }

    const HandlerDeleteRows = (id:string)=>{
      const result = addRows.filter(r=>r.id !== id);
      setAddRows(result);
      HandlerNumError(result);
      ///horas 
      const prevValue = previousValuesMap.current.get(id) || 0;
      setHorasTotal(horasTotal + prevValue);
      previousValuesMap.current.delete(id);
      // files id compuesto
      setListFile(prev => prev.filter(item => !item.id.startsWith(id + '@'))); // Ejemplo de id compuesto: "id@uuid"
      
    }

    const HandlerNombreAct = (id: string, newValue: string | undefined,option:IActivityRecurring) => {
      const valuess = newValue || "";
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreAct: valuess,actividadRecurrenteSelect:option } : r);
      validateRowById(updatedRows,id);
    };

    const HandlerNombreActNuevo = (id:string,text:string)=>{
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreAct:text} : r);
        validateRowById(updatedRows, id);
    }

    const HandlerContHoras = (id: string, newValue: string | undefined, type: 'hour' | 'minute') => {
      const updatedRows = addRows.map(row => {
        if (row.id === id) {
          const [currentHour, currentMinute] = (row.horasCarg || "00:00").split(':');
          const newHour = type === 'hour' ? newValue || '' : currentHour;
          const newMinute = type === 'minute' ? newValue || '' : currentMinute;
          return { ...row, horasCarg: `${newHour}:${newMinute}` };
        }
        return row;
      });
      validateRowById(updatedRows, id);
    };

    const onselectProject = async(option: IComboBoxInput | undefined, id: string, inputText: string | undefined) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombrePro: option || { key: "", text: inputText || "" },nombreAct:"", pro_inicio: option?.pro_inicio, pro_fin: option?.pro_fin} : r);
      validateRowById(updatedRows, id);
      setLoading(true);
      const getListActvityRecurring = await props.system.getLisActivityRecurring(String(option?.key),id);
      if(getListActvityRecurring){
        const updatedRowss = updatedRows.map(r => r.id === id ? { ...r,lisActRecurrente:getListActvityRecurring} : r);
          validateRowById(updatedRowss, id);
      }
      setLoading(false);
    };

    const ProjectFilterChange = (text: string, id: string,listaProyect:IComboBoxOption[]) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombrePro: { ...r.nombrePro, text: text || "" },
        filterListProyectos: listaProyect.filter(g => g.text.toLowerCase().includes(text.toLowerCase()))} : r);
        validateRowById(updatedRows, id);
    };

    const onselecTipoConcept = async(option: ItipoConcepto | undefined, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r,tipoConcepto:option || {key:"",text:"",codigo:""},
        nombrePro:{ key: "", text: ""},listaProyectos:[],filterListProyectos:[],nombreAct:"", actividadRecurrente: "", actividadRecurrenteSelect: undefined, lisActRecurrente: []  }: r);
      validateRowById(updatedRows, id);
      if (option) {
        const exercise_period = formatDate(periodo);
        setLoading(true);
        const data = await fetchProjects(collaboratorId,exercise_period,option?.key);
        if(data){
        const listProyectFiltrado = updatedRows.map(r => r.id === id ? { ...r,listaProyectos:data,filterListProyectos:data} : r);
        validateRowById(listProyectFiltrado, id);
        }
        setLoading(false);
      }
    };

    const onselectCountry = async(option:IComboBoxOption  | undefined, id: string) => {
      let options: IComboBoxOption[] = [];
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              paisEmpresa: option || { key: "", text: "" },
              tipoConcepto: { key: "", text: "", codigo:"" },
              nombrePro: { key: "", text: "" },
              listaProyectos: [],
              listaEmpresa:[],
              filterListProyectos: [],
              nombreAct: "",
              nombreEmp: { key: "", text: "" },
              actividadRecurrente: "", 
              actividadRecurrenteSelect: undefined, 
              lisActRecurrente: []
            }
          : r
      );
      validateRowById(updatedRows, id);
      setLoading(true);
      if (option?.key) {
        const data = await props.system.getCompanySystem().getEmpresasByCountry(option?.key);
        if (data.data.length > 0) {
          const companies = data.data;
          options = companies?.map((company) => ({
            key: company.emp_id,
            text: company.emp_nombre,
          }));
          const listProyectFiltrado = updatedRows.map(r => r.id === id ? { ...r,listaEmpresa:options} : r);
          validateRowById(listProyectFiltrado, id);
        }
      }
      setLoading(false);
    };

    const onselectCompany = async(option:IComboBoxOption  | undefined, id: string) => {
      let options: IComboBoxOption[] = [];
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombreEmp:  option || { key: "", text: "" },
              nombrePro: { key: "", text: "" },
              tipoConcepto: { key: "", text: "", codigo:"" },
              listaProyectos: [],
              filterListProyectos: [],
              nombreAct: "",
            }
          : r
      );
      validateRowById(updatedRows, id);
      // setLoading(true);
      // const data = await props.system.getCompanySystem().getEmpresasByCountry(option?.key);
      // if (data.data.length > 0) {
      //   const companies = Array.isArray(data?.data) ? data.data : [data.data];;
      //   options = companies?.map((company) => ({
      //     key: company.emp_id,
      //     text: company.emp_nombre,
      //   }));
      //   const listProyectFiltrado = updatedRows.map(r => r.id === id ? { ...r,listaEmpresa:options} : r);
      //   validateRowById(listProyectFiltrado, id);
      // }
      // setLoading(false);
    };


    const tipoConceptFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, tipoConcepto: { ...r.tipoConcepto, text: text || "" } } : r);
      const data = listtipoConcept.filter(g => g.text.toLowerCase().includes(text.toLowerCase()));
      setFilterTipoConsept(data);
      validateRowById(updatedRows, id);
    };

    const handlerDescripcion = (data: string | undefined, id:string) => {
      const updatedRows = addRows.map(r => r.id === id? { ...r, descripcion:data || ""}:r);
      validateRowById(updatedRows,id);
    }

    const HandlerPeriodo = async (date:Date)=>{
      props.changeBlockUI(true);
      cleanActiveProject()
      setPeriod(date);
      const exercise_period = formatDate(date);
      await getHorasTal(collaboratorId,exercise_period);
      props.changeBlockUI(false);
    }

    const cleanActiveProject = ()=>{
     setHorasTotal(0);
     setAddRows([]);
     setDesabled(true);
     HandlerNumError([]);
    }

    const cleanActiveProjectsLaterSave = () => {
      setHorasTotal(0);
      setAddRows([]);
      setDesabled(true);
      HandlerNumError([]);
    }

    const formatPeriodToYYYYMMDD = (datePeriod: Date) => {
      const fecha = datePeriod instanceof Date ? datePeriod : new Date(datePeriod);
      return fecha.toISOString().split("T")[0];
    }

    const saveFile = async () => {
      const idFile = await props.system.documentTypeOtherId();
      // Actualizar los archivos en la lista del doctId
      const updatedListFile = listFile.map(item => {
        return {
          ...item,
          file: {
            ...item.file,
            cargaDocumentosItems: item.file.cargaDocumentosItems.map(cargaItem => ({
              ...cargaItem,
              doctId: idFile
            }))
          }
        }
      });

      for (const item of updatedListFile) {
        try {
           await props.system.getActivitySystem().UploadfileForm(item.file, item.path, formatPeriodToYYYYMMDD(periodo));
        } catch (error) {
          console.error('Error uploading file:', error);
        }
      }
    };


    const handleMultipleFiles = async (fileList: File[], project: IComboBoxOption, rowId: string) => {
      const idfolder: any = await getIdfolder(String(project?.key));

      const newFileEntries: IListFile[] = fileList.map((file) => ({
        path: file,
        // Agregar un id compusto para despues poder eliminarlo si eliminan las fila
        id: `${rowId}@${uuidv4()}`,
        file: {
          cmd_proid: project.key,
          cmd_cant_archivos: 1,
          cmd_cant_bytes_total: file.size,
          cmd_tipo: "proyecto",
          folderId: String(idfolder?.pca_id),
          cargaDocumentosItems: [
            {
              cmdi_cant_bytes: file.size,
              cmdi_doc_uuid: "0",
              cmdi_nombre_archivo: file.name,
              cmdi_content_type: file.type,
              doctId: '',
              tipo: "proyecto"
            }
          ]
        }
      }));

      // Agregar o reemplazar archivos para esa fila
      setListFile(prev => {
        return [...prev, ...newFileEntries]
      });

      // Guardar también en la fila
      setAddRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, files: [...(row.files || []), ...fileList] }
            : row
        )
      );
    };

    const handleFileDelete = (index: number, rowId: string) => {
      setAddRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, files: row.files.filter((_, i) => i !== index) }
            : row
        )
      );

      setListFile(prev =>
        prev.filter((item, i) => {
          const isSameRow = item.id.startsWith(rowId + '@'); // Verifica si el id comienza con rowId
          const indexInRow = prev.filter(f => f.id.startsWith(rowId + '@')).indexOf(item);
          return !isSameRow || indexInRow !== index;
        })
      );
    };

    const HandlerNumError = (validados: IAddRows[])=>{
        const actVali = validados.filter(g=>g.valida === 1);
        const actvErro = validados.filter(g=>g.valida === 0);
        const actvEarring = validados.filter(g=>g.valida === 2);
        setActError({actVali:actVali.length,actvErro:actvErro.length});
       if((actvErro.length === 0) && (validados.length !== 0) && (actvEarring.length === 0)){
         setDesabled(false);
       }else{
        setDesabled(true);
       } 
    };

    const onsubmit = async (ev: FormEvent<HTMLFormElement>) => {
      ev.preventDefault();

      // Calcular el total de horas que se intenta registrar en el mes
      const totalHorasCargadas = addRows.reduce((acc, row) => acc + convertHourToMin(row.horasCarg), 0);
      
      // Validar si excede el límite de horas
      if (totalHorasCargadas > horasTotalCollaborator) {
        setShowHoursDialog(true);
        return;
      }

      // Si no se supera el límite de horas, proceder con la carga
      handleConfirmHoursDialog();
    }

    const handleConfirmHoursDialog = async () => {
      props.courier.messageWarning('')
      setShowHoursDialog(false);
      props.changeBlockUI(true);
        if(addRows){
          const tranForm = addRows.map(row =>{
              const numer = convertHourToMin(row.horasCarg as any);
              return {
                impai_nombre: row.nombreAct,
                impai_cantidad_horas : convertMinToHour(numer),
                impai_codigo_proyecto: row.nombrePro.code,
                impai_proid: row.nombrePro.key,
                impai_con_error: false,
                impai_descripcion_error: row.descripcionError,
                impai_descripcion: row.descripcion,
                impai_codigo_empresa: row.nombreEmp.key,
                impai_empresas: [row.nombreEmp.key]
              }
          });
          
          const body:IactivitiesBody = {
            activities:tranForm,
            col_id: collaboratorId, 
            exercise_period:DateCustom.formatDateYYYYMM(periodo), 
            timezone: "America/Lima" 
          };
          setDesabled(true)
          const numProjetct = addRows.length;
          try {
            await props.system.getActivitySystem().saveActivity(headers,body); 
            await saveFile();
            //  cleanActiveProject();
            cleanActiveProjectsLaterSave();
            postPlantillaActividadesXColaborador();
            getHorasTal(collaboratorId,DateCustom.formatDateYYYYMM(periodo));
            props.courier.messageSuccess(t(`Se carg${numProjetct===1?"o":"aron"} ${numProjetct} fila${numProjetct===1?"":"s"} de manera exitosa`));
            setListFile([]);
          } catch (error) {
            console.log(error);
            const apiErrorMessage = error instanceof XhrRequestError ? error.getApiErrorMessage() : '';
            props.courier.messageError(apiErrorMessage || t('Ocurrió un error al importar las actividades. Por favor, intenta nuevamente o contacta al administrador.'));
          }
        }
      props.changeBlockUI(false);
    };

    const handleCancelHoursDialog = () => {
      setShowHoursDialog(false);
    };

    const postPlantillaActividadesXColaborador = async () => {
      const parceData:IPosplantillaActividadesColaborador[] = await Promise.all(addRows.map( async row =>{
        let ar_id:string = row.actividadRecurrenteSelect?.ar_id ||"";
            if(ar_id === ""){
              const recuperation ={
                codigoConcepto:parseInt(row.tipoConcepto.key as string) ,
                codigoProyecto:parseInt(row.nombrePro.key as string),
                nombreActividad:row.nombreAct,
                codigoEmpresa:parseInt(row.nombreEmp.code as string),
                codigoPais:parseInt(row.paisEmpresa.code as string)
              }
              const {ar_id_data} = await props.system.postAddRecurrentActivity(recuperation,headers.idTransaccion);
              ar_id=ar_id_data;
            }
        return{
          paxc_col_id:collaboratorId,
          paxc_data:{
            ar_id:ar_id,
            proy_id:row.nombrePro.key,
            recurrent:row.actividadRecurrente,
            tc_id:row.tipoConcepto.key,
            ar_pais_id:row.paisEmpresa.key,
            ar_empresa_id:row.nombreEmp.key,
            ar_descripcion:row.descripcion,
          }
        }
      })) as any  ;
      
        await props.system.postPlantillaActividadesXColaborador( parceData,headers.idTransaccion);
      
    };

    const getHorasTal = async (col_id:string,exercise_period:string)=>{
      setDesableAddRow(true)
      const body = { col_id,  exercise_period}
      const result = await props.system.getActivitySystem().saveActivityResult(headers,body);
      const data = result as any
      if(data.data){
       setHorasTotal(data?.data?.pending_minutes);
       setHorasExcedidas(data?.data?.excess_hours);
       setHorasTotalCollaborator(data?.data?.pending_minutes);
       setDesableAddRow(()=>false);
      }
    };

    const getListActivityRecurring = async(collaboratorId:string)=>{
      setLoading(true);
      const uuidTransaccion=uuidv4();
      const exercise_period = formatDate(periodo);
      const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(collaboratorId,exercise_period);
      const projectsList =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode() }));
      const projectValided = projectsList.map(item=>item?.key);

        if(projectValided.length !== 0){
          const activity:IPlantillaActividadesXColaborador[] = await props.system.getPlantillaActividadesXColaborador(collaboratorId,headers.idTransaccion,projectValided);
          if(activity.length === 0) {
            HandlerAddRows();
          }else{
                let options: IComboBoxOption[] = [];
                let filterDataCompany: any = [];

                const listActivity:IAddRows[] = await Promise.all (activity.map( async item =>{
                const getListActvityRecurring = await props.system.getLisActivityRecurring(String(item.paxc_data.proy_id),uuidTransaccion);
                //const actvityRecurringFilter = await getListActvityRecurring.find((i) => i.ar_nombre_act === String(item.paxc_data.ar_nombre_act));
                const exercise_period = formatDate(periodo);
                const data = await fetchProjects(collaboratorId,exercise_period,item.paxc_data.tipoConcepto.tc_id);
                const listaCountryData = await props.system.getCountrySystem().getDataCountries();
                const listaCountryTranform: IComboBoxOption[] = listaCountryData.map((country) => ({
                  key: country.pais_id,
                  text: country.pais_nombre,
                }));
                const dataCountry:any = await listaCountryTranform.filter((g) => String(g.key) === String(item?.paxc_data.ar_pais_id));
                if (dataCountry.length > 0) {
                  const dataCompany = await props.system.getCompanySystem().getEmpresasByCountry(dataCountry[0]?.key);
                  if (dataCompany.data.length > 0) {
                    const companies = dataCompany.data;
                    options = companies?.map((company) => ({
                      key: company.emp_id,
                      text: company.emp_nombre,
                    }));
                  }
                  filterDataCompany = options.filter((g) => g.key === item?.paxc_data.ar_empresa_id);
                }

                const newdata: IAddRows = {
                id: uuidv4(),
                nombrePro: { key: item.paxc_data.proy_id, text:item.paxc_data.pro_nombre },
                nombreAct: item.paxc_data.ar_nombre_act,
                horasCarg: "",
                file: "",
                valida: 2,
                descripcionError: t("actividades recurrentes"),
                actividadRecurrente:item.paxc_data.recurrent,
                lisActRecurrente:getListActvityRecurring,
                actividadRecurrenteSelect:{...actividadRecurrentenbasic,ar_id:item.paxc_data.ar_id},
                tipoConcepto:{key:item.paxc_data.tipoConcepto.tc_id,
                              text:item.paxc_data.tipoConcepto.tc_nombre,codigo:item.paxc_data.tipoConcepto.tc_codigo},
                listaProyectos:data || [],
                listaEmpresa: [],
                filterListProyectos:data || [],
                descripcion: item.paxc_data.ar_descripcion ||"",
                paisEmpresa: dataCountry[0] ||  { key: "", text: "" },
                nombreEmp: filterDataCompany[0] || { key: "", text: "" },
                options:0,
                files: []
              };
                return newdata;
              }))
              setAddRows(listActivity);
          }
        }
        setLoading(false);
    }

    const cleanHour = (value: string) => {
      if (!value) return "00:00";
      return value.replace(/^="?/, "").replace(/"$/, "");
    };

    const HandlerDataToExcel = () => {
      const dataExcel: any[][] = [];
      const zeroWidthSpace = '\u200B';

      addRows.forEach((row: IAddRows) => {
        dataExcel.push([
          row.paisEmpresa.text,
          row.nombreEmp.text,
          row.tipoConcepto.text,
          row.nombrePro.text.toString(),
          `${zeroWidthSpace}${row.nombreAct?.toString()}`,
          `${zeroWidthSpace}${row.descripcion?.toString()}`,
          row.horasCarg ? `="${row.horasCarg}"` : "00:00"
        ]);
      });

      return dataExcel;
    };

    const HandlerDataFromExcel = async (data: any[][]) => {
      setAddRows([]);
      let options: IComboBoxOption[] = [];

      for (const row of data) {
        setLoading(true);
        let datatipoConcepto = listtipoConcept.filter((g) =>
          normalizeText(g.text).includes(normalizeText(row[2]))
        );
        const dataCountry = listCountries.filter((g) =>
          normalizeText(g.text).includes(normalizeText(row[0]))
        );

        const dataCompany = dataCountry[0]?.key ? await props.system.getCompanySystem().getEmpresasByCountry(dataCountry[0]?.key) : { data: [] }
        if (dataCompany.data.length > 0) {
          const companies = dataCompany.data;
          options = companies?.map((company) => ({
            key: company.emp_id,
            text: company.emp_nombre,
          }));
        }
        const filterDataCompany = options.filter((g) =>
          normalizeText(g.text) === normalizeText(row[1]
        ));
        const exercise_period = formatDate(periodo);
        const dataProject = await fetchProjects(
          collaboratorId,
          exercise_period,
          datatipoConcepto[2]?.key
        );
        const datanombrePro = dataProject?.find(
          (g) =>
            row[3].trim() !== "" &&
            normalizeText(g.text) === normalizeText(row[3]) 
        );

        if (datanombrePro && datatipoConcepto.length > 0) {
          // Validar si el proyecto corresponde al tipo de concepto porque el usuario puede haber ingresado un proyecto que no corresponde al tipo de concepto seleccionado
          const tipoConceptoValido = datanombrePro.code.startsWith(datatipoConcepto[0].codigo, 0); // Example: "PROFA2025-30" -> "PRO"
          if (!tipoConceptoValido) {
           datatipoConcepto = [];
          }
        }

        const newdata: IAddRows = {
          id: uuidv4(),
          nombrePro: {
            key: datanombrePro?.key || "",
            text: datanombrePro?.text || "",
            code: datanombrePro?.code || "",
          },
          nombreAct: row[4] || "",
          horasCarg: cleanHour(row[6]),
          file: "",
          valida: 2,
          descripcionError: t("nueva fila"),
          actividadRecurrente: "si",
          lisActRecurrente: [],
          actividadRecurrenteSelect: actividadRecurrentenbasic,
          tipoConcepto: datatipoConcepto[0],
          listaProyectos: dataProject || [],
          listaEmpresa: options || [],
          filterListProyectos: dataProject || [],
          descripcion: row[5]?.trim() || "",
          paisEmpresa: dataCountry[0] || [],
          nombreEmp: filterDataCompany[0] || [],
          options:0,
          files: []
        };

        setAddRows((prevRows) => [...prevRows, newdata]);
        const getListActvityRecurring = datanombrePro?.key ? await props.system.getLisActivityRecurring(
            String(datanombrePro?.key),
            newdata.id
          ) : []

        setAddRows((prevRows) =>
          prevRows.map((r) =>
            r.id === newdata.id
              ? {
                  ...r,
                  nombreAct: row[4] ? row[4].trim() : "",
                  lisActRecurrente: getListActvityRecurring,
                }
              : r
          )
        );

        setAddRows((prevRows) =>
          prevRows.map((r) =>
            r.id === newdata.id ? validateRow(r, newdata.id) : r
          )
        );
      }
      setAddRows(prevRows => {
        const allValid = prevRows.every(row => row.valida === 1);
        if (allValid ) {
          setDesabled(false);
        } else {
          setDesabled(true);
        }
        return prevRows; // Mantener el estado
      });
      setLoading(false);
    };

    const handlerDuplicateRow = (data: any) => {
      const newData = { ...data, id: uuidv4(), options:0};
      setAddRows([...addRows, newData]);
      setDesabled(true);
    }

    const countryFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, paisEmpresa: { ...r.paisEmpresa, text: text || ""}} : r);
      validateRowById(updatedRows, id);
    };

    const companyFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreEmp: { ...r.nombreEmp, text: text || ""}} : r);
      validateRowById(updatedRows, id);
    };

    const onClickCallout = (id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, options: r.options === 0 ? 1 : 0 }: r);
      validateRowById(updatedRows, id);
    }

    const toggleTooltip = () => {
      if (isMobile) {
        setTooltipVisible(!tooltipVisible);
      }
    };

    useEffect(() => {
      if(collaboratorId ){
        getListActivityRecurring(collaboratorId);
        setLoading(false);
      }
    },[periodo,collaboratorId]);

    useEffect(()=>{
      getLisTipoConcept();
      getAllPeriodBlocks();
      getListCountries();
      if(props.user){
        handleSelectCollaborator({key:props.user.getCollaboratorId(),text:props.user.getCollaborator().getName() +" "+ props.user.getCollaborator().getLastName()});
      }
      fetchCollaborators()
    },[]);

    if (!props.loading) {
      return <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
    }

    return (
      <form
        className="ms-Grid"
        dir="ltr"
        style={{
          minHeight: "100%",
          fontFamily:
            'Segoe UI, "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
        }}
        onSubmit={onsubmit}
      >
        <FormUploadHeader />
        <Custoneader
          mountBlock={mountBlock}
          filteredCollaborators={filteredCollaborators}
          collaboratorValue={collaboratorValue}
          handleSelectCollaborator={handleSelectCollaborator}
          handleFilterCollaborator={handleFilterCollaborator}
          periodo={periodo}
          HandlerPeriodo={HandlerPeriodo}
          horasTotal={horasTotal}
          addrowlength={addRows.length}
          convertMinToHour={convertMinToHour}
          desabled={desabled}
          UploadIcon={UploadIcon}
          actError={actError}
          tipoConcept={listtipoConcept}
          desableAddRow={desableAddRow}
          HandlerAddRows={HandlerAddRows}
          AddIcon={AddIcon}
          dataUser={props.user}
          HandlercleanEverything={HandlercleanEverything}
          HandlerCopyToClipboard={HandlerDataToExcel}
          HandlerDataFromExcel={HandlerDataFromExcel}
          courier={props.courier}
        />
        <br />
        <br />
        <div>
          <div>
            <div>
              <hr />
              <div style={{ position: "relative", maxWidth: 1420, margin: '0 auto' }}>
                {loading && <LoadingPage />}
                {addRows.map((row) => (
                  <ActivityRow 
                    key={row.id}
                    row={row}
                    aiActivityEnhancementSystem={aiActivityEnhancementSystem}
                    isMobile={isMobile}
                    listCountries={listCountries}
                    HandlerContHoras={HandlerContHoras}
                    HandlerDeleteRows={HandlerDeleteRows }
                    HandlerNombreAct={HandlerNombreAct}
                    HandlerNombreActNuevo={HandlerNombreActNuevo}
                    ProjectFilterChange={ProjectFilterChange}
                    companyFilterChange={companyFilterChange}
                    countryFilterChange={countryFilterChange}
                    filterTipoConsept={filterTipoConsept}
                    handlerDescripcion={handlerDescripcion}
                    handlerDuplicateRow={handlerDuplicateRow}
                    onClickCallout={onClickCallout}
                    onselecTipoConcept={onselecTipoConcept}
                    onselectCompany={onselectCompany}
                    onselectCountry={onselectCountry}
                    onselectProject={onselectProject}
                    setTooltipVisible={setTooltipVisible}
                    tipoConceptFilterChange={tipoConceptFilterChange}
                    toggleTooltip={toggleTooltip}
                    updateActivityNameAndDescription={updateActivityNameAndDescription}
                    handleMultipleFiles={handleMultipleFiles}
                    handleFileDelete={handleFileDelete}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

      <HoursLimitDialog
        isOpen={showHoursDialog}
        horasExcedidas={horasExcedidas}
        onConfirm={handleConfirmHoursDialog}
        onCancel={handleCancelHoursDialog}
      />
      </form>
    );
}

export default CargarPorFormulario